export default [
  {
    path: "/C51T1fftoU3aUC6ikLxf",
    children: [
      {
        path: "",
        name: "student-cat-list",
        meta: {
          title: "Student Groups",
          authRequired: true,
          acc: ["y57389"],
        },
        component: () => import("../views/students-group/index.vue"),
      },
      {
        path: "IAYM3QN0c1V1eusjCeOl",
        name: "view-student-cat",
        meta: {
          title: "Student Group",
          authRequired: true,
          acc: ["y53829"],
          breadcrumb: {
            route: "student-cat-list",
          },
        },
        component: () => import("../views/students-group/view.vue"),
      },
      {
        path: "vzwBz6TLSKEzKrK6fwRl",
        name: "create-student-cat",
        meta: {
          title: "Create Student Group",
          authRequired: true,
          acc: ["y96643"],
        },
        component: () => import("../views/students-group/create.vue"),
      },
      {
        path: "7qflCAZ12lDXl0W5H4BX",
        name: "update-student-cat",
        meta: {
          title: "Update Student Group",
          authRequired: true,
          acc: ["y15131"],
          breadcrumb:{
                route: 'student-cat-list'
            
            },
        },
        component: () => import("../views/students-group/update.vue"),
      },
    ],
  },
];
